import { ChartManager } from "..";

/**
 * Classe gerenciadora do card de correlação. Reusa toda a orquestração do ChartManager
 * (ciclo de cores, highlit, color picker, atualização das opções) — os pontos de
 * customização específicos do gráfico (treemap, e futuramente bubble/simple_bubble)
 * vivem nos resolvers de echart option e nas estratégias de updateOnly por identifier.
 */
export class CorrelationChartManager extends ChartManager {
  // O data bruto vindo da correlação já está no formato consumido pelo dataProcessor
  // do treemap (estrutura hierárquica de alternativas → perguntas → alternativas
  // correlacionadas), então não precisa de pré-processamento.
  formatData(data) {
    return data;
  }

  /**
   * @Override
   * Sobrescreve o comportamento default de ThemeManager#handlOnDoubleClick
   * para aplicar validações específicas de exibição.
   */
  handleOnDoubleClick(eventContext) {
    /**
     * Para gráfico do tipo GraphBubble, desabilitamos o color picker para
     * perguntas principais (acontece se data.parent === 'undefined', indicando
     * que este nó é uma raíz, e não deve ser computado como um item customizável
     * do gráfico, ele existe apenas para estruturar o grafo visualmente.)
     */
    if (this.isCorrelationGraphBubbleChart()) {
      const { data } = eventContext;

      if (typeof data?.parent === "undefined") {
        return;
      }
    }

    /**
     * Para gráfico do tipo TreeMap (correlação) o breadcrumb renderizado centralmente
     * no canto inferior é identificado como um item clicável, acionando o color picker.
     * Para este componente, queremos evitar este comportamento, e por isso o desabilitamos.
     */
    if (this.isCorrelationTreeMapChart()) {
      if (eventContext?.selfType === "breadcrumb") {
        return;
      }
    }

    super.handleOnDoubleClick(eventContext);
  }

  isCorrelationGraphBubbleChart() {
    return super.getIdentifier() === 'correlationChartCard_graph_bubble';
  }

  isCorrelationTreeMapChart() {
    return super.getIdentifier() === 'correlationChartCard_tree_map';
  }

}
